import { IComponent } from '../interfaces';

export const ComponentsConstant: Array<IComponent> = [
    { htmlTag: 'bs-date-catcher', component: () => import('../components/bs-date-catcher')},
    { htmlTag: 'bs-pagination', component: () => import('../components/bs-pagination')},
    { htmlTag: 'gp-multiselect', component: () => import('../components/gp-multiselect')},
    { htmlTag: 'bs-multiselect-filter', component: () => import('../components/bs-multiselect-filter')},
];
